require('./RAHireManagementPlanStep3.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const RAOneLineSymbolAmount = require('../../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const {
    buildAccountsDropdownOptions,
} = require('../../../utilities/RAAccountsHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { recordProcess } = require('utilities/tagging');

// @constants
const {
    BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER,
    FIRST_STEP,
    THIRD_STEP,
} = require('constants/index');
const { RA_INVESTMENT_TYPE_FOUNDS } = require('../../../raConstants/index');
const { PROPC_RA_HIRE_MANAGEMENT_PLAN } = require('utilities/tagging');

class RAHireManagementPlanStep3 extends React.Component {
    componentDidMount() {
        const customData = {
            pageName: '/contractingRobo/step3/bankDetails',
            sectionFamily: 'wealth',
            sectionCategory: 'products',
            sectionName: 'robo',
            serviceType: 'productContracting',
            interactionType: 'funnel',
            processType: 'contractingRobo',
            processStep: `step3`,
            processDetail: 'bankDetails',
            productName: 'robo',
        };
        recordProcess('', '', customData, true);
    }

    componentDidUpdate() {
        const { immSteps } = this.props;
        const isHiringWithFunds =
            immSteps.getIn([FIRST_STEP, 'investmentType']) ===
            RA_INVESTMENT_TYPE_FOUNDS;
        if (!isHiringWithFunds && immSteps.getIn([THIRD_STEP, 'errorFlags'])) {
            taggingEventHandled(
                PROPC_RA_HIRE_MANAGEMENT_PLAN,
                'step3_errorAccountInput',
                {
                    descripcionError: formatText(
                        'raHireManagementPlanStep2-accountErrorMessage',
                    ),
                },
            );
        }
    }

    buildAccountsDropdownSection(
        immAccounts,
        immSteps,
        immSelectedAccountsWithFunds,
    ) {
        const isHiringWithFunds =
            immSteps.getIn([FIRST_STEP, 'investmentType']) ===
            RA_INVESTMENT_TYPE_FOUNDS;
        const selectedIds = immSelectedAccountsWithFunds.keySeq();
        const stockContractOptions = buildAccountsDropdownOptions(
            immAccounts,
            isHiringWithFunds,
            selectedIds,
        );
        const errorState =
            !isHiringWithFunds && immSteps.getIn([THIRD_STEP, 'errorFlags']);
        const immAccountsConditional = isHiringWithFunds ? null : immAccounts;
        const isBlockedAccountsLoading = immAccounts.get(
            'blockedAccountsLoading',
        );

        return (
            <div>
                <FormattedText
                    value="raHireManagementPlanStep2-infoMsg"
                    className="ra-hire-management-plan-step3__info"
                />
                <StocksContractDropdown
                    immAccounts={immAccountsConditional}
                    errorMessage={formatText(
                        'raHireManagementPlanStep2-accountErrorMessage',
                    )}
                    errorState={errorState}
                    label="raHireManagementPlanStep2-selectAccountLabelNew"
                    modifier={
                        BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER
                    }
                    onStockContractChange={this.props.onAccountChange}
                    options={stockContractOptions.toArray()}
                    placeholder={formatText('transfers-selectAccount')}
                    selectedValue={immSteps.getIn([
                        THIRD_STEP,
                        'selectedAccount',
                    ])}
                    showLabel={false}
                    loading={isBlockedAccountsLoading}
                />
            </div>
        );
    }

    buildSelectedAccountInfo(immAccounts, immSteps, immProfile) {
        const selectedAccount = immSteps.getIn([THIRD_STEP, 'selectedAccount']);
        const amountObject = immAccounts
            .getIn(['byId', selectedAccount, 'balances', 'availableBalance'])
            .toJS();
        const balanceAmountBlock = (
            <RAOneLineSymbolAmount amountObject={amountObject} />
        );
        const userFullName = immProfile.get('fullname');

        return (
            <div>
                <div className="print-label">
                    <span className="ra-hire-management-plan-step3__info-account-name">
                        {immAccounts.getIn([
                            'byId',
                            selectedAccount,
                            'description',
                        ])}
                    </span>
                </div>
                <div>
                    <FormattedTextWithComponents
                        value="raHireManagementPlanStep2-selectAccountInfo"
                        className="ra-hire-management-plan-step3__info-account"
                        injectedComponents={[balanceAmountBlock, userFullName]}
                    />
                </div>
            </div>
        );
    }

    render() {
        const {
            active,
            immAccounts,
            immProfile,
            immSteps,
            immSelectedAccountsWithFunds,
        } = this.props;
        let section;

        if (active) {
            section = this.buildAccountsDropdownSection(
                immAccounts,
                immSteps,
                immSelectedAccountsWithFunds,
            );
        } else {
            section = this.buildSelectedAccountInfo(
                immAccounts,
                immSteps,
                immProfile,
            );
        }

        return (
            <div className="ra-hire-management-plan-step3">
                <div className="row">
                    <div className="col-md-12">{section}</div>
                </div>
            </div>
        );
    }
}

RAHireManagementPlanStep3.propTypes = {
    active: PropTypes.bool.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSteps: PropTypes.object.isRequired,
    immSelectedAccountsWithFunds: PropTypes.object.isRequired,
    onAccountChange: PropTypes.func.isRequired,
};

module.exports = RAHireManagementPlanStep3;
